import type { CalendarEventActionSource } from './CalendarEventActionSource';
import { deleteCalendarEvent as deleteCalendarEventAction } from 'owa-calendar-events-actions';
import type CalendarEvent from 'owa-calendar-types/lib/types/CalendarEvent';
import EventScope from 'owa-service/lib/contract/EventScope';

export default async function deleteCalendarEvent(
    actionSource: CalendarEventActionSource,
    event: Readonly<CalendarEvent>
) {
    // NOTE: owa-calendar-events-actions/lib/orchestrators/deleteCalendarEventOrchestrator.ts
    // is not returning errors, like the other orchestrators. We might need to fix or move away from it.
    await new Promise<void>(resolve =>
        deleteCalendarEventAction(event, actionSource, EventScope.Default, resolve)
    );
}
